import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 088BF56F-9281-43DB-879E-EB5158428EB7
 * name flash-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flash-outline.svg
 * tags
 * - Weather 
 */
export const FlashOutlineIcon = createSvgIcon(<><path d="M7,2H17L13.5,9H17L10,22V14H7V2M9,4V12H12V14.66L14,11H10.24L13.76,4H9Z" /></>, 'FlashOutlineIcon');
export default FlashOutlineIcon